module.exports = __webpack_public_path__ + "img/MDI-certificate-disabled.992ab1a4.svg";